module.exports = __webpack_public_path__ + "img/manage-orders-hover.f905a12b.svg";